import Panolens from '@perxteam/react-panorama-view/lib/panolens/panolens';
import { hotspotImages } from './hotspots';

class PanolensUtils {
  static mainHotpostTexture: any;

  static hoverHotspotTexture: any;

  static panolensInstance: Panolens;

  static createHotspotTextures(panolens: Panolens) {
    PanolensUtils.mainHotpostTexture = panolens.panolensLib.TextureLoader.load(
      hotspotImages.mainImage
    );

    PanolensUtils.hoverHotspotTexture = panolens.panolensLib.TextureLoader.load(
      hotspotImages.hoverImage
    );
  }

  static hideWithAnimation(infospot: any) {
    const hideAnimation = PanolensUtils.createAnimation(infospot, 'hide');
    hideAnimation.start();
  }

  static showWithAnimation(infospot: any) {
    const hideAnimation = PanolensUtils.createAnimation(infospot, 'show');
    hideAnimation.start();
  }

  static createAnimation(infospot: any, animationType: 'hide' | 'show') {
    const { TWEEN } = window as any;
    const animation = new TWEEN.Tween(infospot.material)
      .to(
        {
          opacity: animationType === 'hide' ? 0.3 : 1,
        },
        400
      )
      .easing(TWEEN.Easing.Quartic.Out);

    return animation;
  }
}

export default PanolensUtils;
